import src from "IMAGE";
export default { src, width: 15, height: 11, blurWidth: 0, blurHeight: 0};
